const digest = '21ef7b59c4451408eb232ddeebd07bfd0034181a25368801362d1818010f3493';
const css = `._roomsSelectorWrapper_z7lx8_1{padding-bottom:10px;padding-top:10px}._roomsSelectorWrapper_z7lx8_1 :focus{border-radius:.5rem}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'roomsSelectorWrapper': '_roomsSelectorWrapper_z7lx8_1' };
export const roomsSelectorWrapper = '_roomsSelectorWrapper_z7lx8_1';
export { css, digest };